// Angular
import { Injectable } from "@angular/core";
// RxJS
import { BehaviorSubject } from "rxjs";
// Object path
import * as objectPath from "object-path";
// Services
import { MenuConfigService } from "./menu-config.service";

import { StateService } from '../../../../services/App/state.service';

@Injectable()
export class MenuAsideService {
	// Public properties
	classes: string;
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
private rights: any;
	/**
	 * Service Constructor
	 *
	 * @param menuConfigService: MenuConfigService
	 * @param store: Store<AppState>
	 */
	constructor(private menuConfigService: MenuConfigService,
		
		private stateService: StateService,
		
	) {
		this.stateService.application.subscribe((res) => {
		               this.rights = res;
		               this.loadMenu();
		         });
		
		//this.loadMenu();
	}

	/**
	 * Load menu
	 */
	loadMenuOld() {
		// get menu list
		const menuItems: any[] = objectPath.get(
			this.menuConfigService.getMenus(),
			"aside.items"
		);
		this.menuList$.next(menuItems);
	}
	
	
	loadMenu() {
			// get menu list
			
	            let tmpList = [];
	        // get menu list
	        const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');
	        menuItems.forEach((menu: any) => {
	           // console.log('MenuAsideService',menu,this.rights)
	            if ((menu.right!==undefined && Object.keys(this.rights).indexOf(menu.right) != -1
	            && this.rights[menu.right]===true
	            )
	                            || (menu.right===true)
	                        ) {
					if (menu.submenu!==undefined) {
						 let ssbu:any=[];
						 menu.submenu.forEach((sub: any) => {
							  if ((sub.right!==undefined && Object.keys(this.rights).indexOf(sub.right) != -1
							   && this.rights[sub.right]===true
							  )
	                            || (sub.right===true)
	                        ) 
								ssbu.push(sub);
						 })
						 menu.submenu=ssbu; 
					}			
								
	                tmpList.push(menu);
	            }
	        });
	        
	        this.menuList$.next(tmpList);
	        /*
	        const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');
	        this.menuList$.next(menuItems);
	        
	        */
			
		}
}
